import React, { useCallback } from 'react';

import { forTemplate } from '@trello/i18n';
import { Button } from '@trello/nachos/button';
const { Analytics } = require('@trello/atlassian-analytics');

const format = forTemplate('notification_supplement');

interface RequestAccessBoardInviteData {
  board: {
    id: string;
    name?: string;
    shortLink?: string;
  };
  card?: {
    id: string;
  };
  inviteMemberId: string;
}

export const RequestAccessBoardInviteSupplement: React.FunctionComponent<RequestAccessBoardInviteData> = ({
  board,
  card,
  inviteMemberId,
}) => {
  const onInviteToBoardButtonClick = useCallback(() => {
    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'requestAccessInviteToBoard',
      source: 'requestAccessInAppNotification',
      containers: {
        board: {
          id: board.id,
        },
        card: {
          id: card?.id,
        },
      },
      attributes: {
        reason: 'Unauthorized',
        requestorId: inviteMemberId,
        cohort: 'experiment',
        shortlink: board.shortLink,
      },
    });

    window.location.assign(
      `/b/${board.shortLink}/${board.name}?inviteMemberId=${inviteMemberId}`,
    );
  }, [board.id, board.name, board.shortLink, inviteMemberId, card?.id]);

  return (
    <Button onClick={onInviteToBoardButtonClick} appearance="default">
      {format('invite-to-board')}
    </Button>
  );
};
